import useSWR from "swr"
import { DeliveryManagementApi } from "../../../apis"
import type { IDeliveryStats } from "../../../apis/delivery-management"

export function useDeliveryStats() {
  const { data, error, isLoading, mutate } = useSWR<IDeliveryStats>(
    "swr.delivery.stats",
    () => DeliveryManagementApi.stats(),
    { revalidateOnFocus: false, refreshInterval: 30_000 },
  )
  return { stats: data, error, isLoading, refresh: mutate }
}
